import { getBaseData } from "@/common/service/apiaggregator/apiAgreegatorService";
import { convertToLowerCase } from "@/common/utils/generic/commonHelper.js";

const createCustomKeyValuePair = (item, isAllKeyValueRequired = false, isValueNameDiffer = false) => {
  const newArrayList = isAllKeyValueRequired ? [{ value: "ALL", label: "All" }] : [];
  if (item && item.length > 0) {
    for (const childItem of item) {
      let tempItem = childItem;
      // This is a temporary fix, In backend lot of changes required for this, so it is handled in UI
      tempItem.label = childItem.value === "Bay Plan" ? "BAPLIE Notification" : childItem.value;
      if (isValueNameDiffer) {
        tempItem.value = childItem.name;
      }
      newArrayList.push(tempItem);
    }
  }
  return newArrayList;
};

//Method to format Manifest data for Each Country
const formatManifestData = item => {
  if (item && item.length > 0) {
    for (const childItem of item) {
      getSortedData(childItem.countries);
    }
  }
};

//Function to Sort the Array of Object
const getSortedData = data => {
  return data.sort(function(a, b) {
    const nameA = a.value.toUpperCase(); // ignore upper and lowercase
    const nameB = b.value.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
};

const state = {
  complianceTypeList: [],
  bolStatusList: [],
  bolStageList: [],
  manifestTypeCountryList: [],
  countryList: [],
  notificationCountryList: [],
  ensNotificationCodeList: [],
  dispositionCodeList: [],
  externalCustomsStatusList: [],
  customsNotificationStatusList: []
};

const getters = {
  getBaseData: state => category => {
    return state[category];
  }
};

const mutations = {
  setCountryList(state, data) {
    state.countryList = data;
  },
  setNotificationCountryList(state, data) {
    state.notificationCountryList = data;
  },
  setComplianceTypeList(state, data) {
    state.complianceTypeList = data;
  },
  setBolStatusList(state, data) {
    state.bolStatusList = data;
  },
  setLoadingState(state, param) {
    state[`${param.type}Loader`] = param.value;
  },
  setBolStageList(state, data) {
    state.bolStageList = data;
  },
  setManifestTypeCountries(state, data) {
    state.manifestTypeCountryList = data;
  },
  setEnsNotificationCodeList(state, data) {
    state.ensNotificationCodeList = data;
  },
  setDispositionCodeList(state, data) {
    state.dispositionCodeList = data;
  },
  setExternalCustomsStatusList(state, data) {
    state.externalCustomsStatusList = data;
  },
  setCustomsNotificationStatusList(state, data) {
    state.customsNotificationStatusList = data;
  },
  setErrorState(state, param) {
    state[`${param.type}Error`] = param.error
      ? "has Error" in param.error
        ? param.error
        : { hasError: true, status: param.error.status, message: param.error.message }
      : null;
  }
};
const actions = {
  async fetchBaseData({ commit }) {
    try {
      let response = await getBaseData();
      for (const item of response) {
        if (convertToLowerCase(item.category) === "compliance-type") {
          getSortedData(item.baseData);
          commit("setComplianceTypeList", createCustomKeyValuePair(item.baseData));
        } else if (convertToLowerCase(item.category) === "bol-status") {
          commit("setBolStatusList", createCustomKeyValuePair(item.baseData));
        } else if (convertToLowerCase(item.category) === "bol-stage") {
          commit("setBolStageList", createCustomKeyValuePair(item.baseData));
        } else if (convertToLowerCase(item.category) === "live-countries") {
          commit("setCountryList", createCustomKeyValuePair(item.baseData));
        } else if (convertToLowerCase(item.category) === "manifest-type-countries") {
          //Method to format Each Country list the sorted format
          formatManifestData(item.baseData);
          commit("setManifestTypeCountries", createCustomKeyValuePair(item.baseData));
        } else if (convertToLowerCase(item.category) === "notification-live-countries") {
          commit("setNotificationCountryList", createCustomKeyValuePair(item.baseData));
        } else if (convertToLowerCase(item.category) === "ens-notification-code-list") {
          commit("setEnsNotificationCodeList", createCustomKeyValuePair(item.baseData));
        } else if (convertToLowerCase(item.category) === "disposition-code-list") {
          commit("setDispositionCodeList", createCustomKeyValuePair(item.baseData));
        } else if (convertToLowerCase(item.category) === "external-customs-status") {
          commit("setExternalCustomsStatusList", createCustomKeyValuePair(item.baseData));
        } else if (convertToLowerCase(item.category) === "customs-notification-status") {
          commit("setCustomsNotificationStatusList", createCustomKeyValuePair(item.baseData));
        }
      }
    } catch (e) {
      commit("setCountryList", []);
      commit("setNotificationCountryList", []);
      commit("setBolStageList", []);
      commit("setBolStatusList", []);
      commit("setComplianceTypeList", []);
      commit("setManifestTypeCountries", []);
      commit("setExternalCustomsStatusList", []);
      commit("setCustomsNotificationStatusList", []);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
